import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Select from 'react-select';
import { FieldLike, SCOPE_TABS, Tabs, getOptionsForProgramType } from './utils';
import { getProjectType, checkMulti } from '../../utils';
import { DateField } from './schedule_utils';

import { withAuth } from '../../actions/';
import { MdPrint } from 'react-icons/lib/md';

const FIELD_MAP = {
	phase: 'projectPhases',
	projectType: 'projectTypes',
	priority: 'priorities',
	designContractType: 'contractTypes',
	constructionContractType: 'constructionContractTypes',
}

class InfoForm extends React.Component {
	constructor(props) {
		super(props);

		this.infoFields = [
			'phaseName', 'projectType', 'priority', 'designContractType', 'constructionContractType', 'phase',
			'projectId', 'projectDescription', 'subPhase', 'designGroup', 'designBy', 'cmBoro', 'cmBoard', 'infraType', 'benchmarkStatus', 'isReadOnlySubPhase',
			'constructionFiscalYear', 'designFiscalYear', 'programTypeId', 'previousFiscalYear', 'critical', 'projectDeliveryMethod'
		];

		this.state = {
			info: _.pick(this.props.info, this.infoFields),
			activeTab: 'scope',

			isOpen: false,

			subPhasesByPhase: [],
			aeRequiredAttributes: this.getRequiredAttr(),

			wsEditable: false,
			webScope: this.props.info.webScope
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.setActiveTab = this.setActiveTab.bind(this);
		this.editWebScope = this.editWebScope.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleSelectChangePhase = this.handleSelectChangePhase.bind(this);
		this.handleSelectChangeMulti = this.handleSelectChangeMulti.bind(this);
		this.handleSelectChangeSingle = this.handleSelectChangeSingle.bind(this);
		this.handleChangeWs = this.handleChangeWs.bind(this);
		this.saveWs = this.saveWs.bind(this);
		this.cancelWs = this.cancelWs.bind(this);

		const today = new Date();
		const targetYear = today.getFullYear() + 7;
		this.fiscalYears = [];

		let year;
		for (year = 2008; year <= targetYear; year++)
			this.fiscalYears.push({ label: year, value: year });
	}

	getRequiredAttr() {
		let requriedAttributes =  {
			benchmarkStatus: '',
			phase: '',
			subPhase: '',
			previousFiscalYear: '',
		}
		if(this.props.info.divisionName === 'Public Buildings'){
			requriedAttributes = {...requriedAttributes,projectDeliveryMethod:'' }
		}
		return requriedAttributes;
	}

	UNSAFE_componentWillMount() {
		if (this.props.info.phase === 'Procurement') {
			const info = { ...this.state.info, isReadOnlySubPhase: true };
			this.setState({ info });
		}

		const { projectTypesSelected, projectTypes } = this.props;
		let ptsArr = [];

		if (this.state.info.projectTypesSelected === undefined) {

			projectTypesSelected.forEach(function (pts) {
				ptsArr.push({
					label: getProjectType(projectTypes, pts.projectTypeId), value: pts.projectTypeId,
					isMultiSelect: checkMulti(projectTypes, pts.projectTypeId)
				});
			});

			const info = { ...this.state.info, projectTypesSelected: ptsArr };
			this.setState({ info });
		}
	}

	toggleModal() {
		const { projectId } = this.props.info;
		let url = `projects/${projectId}/statusreport`;

		let method = 'get';
		let responseType = 'arraybuffer';
		this.setState({ loader: true });
		withAuth(
			{ method, url, responseType },
			(response) => {
				//this.closeModal();
				//alert(data.data);
				this.setState({ loader: false });
				var data = response.data;
				var contentType = 'application/pdf';
				var blob = new Blob([data], { type: contentType });
				var downloadUrl = window.URL.createObjectURL(blob);
				window.open(downloadUrl, '_blank');
			},
			this.errorHandler
		)
	}

	getOptionsFor(field) {
		const values = this.props.setup[FIELD_MAP[field]];
		if (values) {
			return values.map(value => {
				return { label: value, value }
			});
		}
	}

	getOptionsForStatus() {
		const values = this.props.benchmarkStatuses;
		if (values) {
			return values.map(value => {
				return { label: value, value }
			});
		}
	}

	getOptionsForPhase() {
		const values = _.uniqBy(this.props.subPhases.filter(c => c.divisionName === this.props.info.divisionName), 'phaseName');
		if (values.length > 0) {
			return values.map(value => {
				return { label: value.phaseName, value: value.phaseName }
			});
		}
	}


	getOptionsForSubPhase(subPhases) {
		const values = subPhases;
		if (values.length > 0) {
			return values[0].subPhases.map(value => {
				return { label: value, value }
			});
		}
	}

	setActiveTab(tab) {
		this.setState({ activeTab: tab });
	}

	changeHandler(name) {
		return (e) => {
			const info = { ...this.state.info }
			info[name] = e.target.value;
			this.setState({ info });
		}
	}

	changeHandlerNumber(name) {
		return (e) => {
			const info = { ...this.state.info }
			var num = e.target.value.match(/^\d+$/);

			if (num === null) {
				info[name] = '';
				this.setState({ info });
			}
			else {
				info[name] = e.target.value;
				this.setState({ info });
			}
		}
	}

	handleCancel(e) {
		e.preventDefault();
		this.props.onCancel();
	}

	handleSubmit(e) {
		e.preventDefault();

		let newInfo = {
			...this.props.info,
			...this.state.info,
		};


		if (this.state.info.phase == "Design" && this.props.info.divisionName == 'Public Buildings') {
			newInfo.subPhase = this.props.phaseName
		}

		const { aeRequiredAttributes } = this.state;

		for (var attr in aeRequiredAttributes) {
			if (newInfo[attr] === null || newInfo[attr] === '' || newInfo[attr] === undefined){
				if(newInfo.divisionName==='Public Buildings' && (attr==='previousFiscalYear')){
					aeRequiredAttributes[attr] = '';
				}
				else{
					aeRequiredAttributes[attr] = 'validateSelect';
				}
			}
			else{
				aeRequiredAttributes[attr] = '';
			}

		}

		this.setState({ aeRequiredAttributes });

		let aeAttrToArray = Object.values(aeRequiredAttributes);
		let isValid = aeAttrToArray.some(prop => prop === 'validateSelect') === false;

		if (isValid) {
			this.props.onSubmit(newInfo);
		}
	}

	handleSelectChange(field) {

		return (option) => {
			const value = option ? option.value : null;
			const info = { ...this.state.info, [field]: value }
			this.setState({ info });
		}
	}

	handleSelectChangeMulti(selectedOptions) {
		var isArray = Array.isArray(selectedOptions);


		if (selectedOptions.length === 0) {
			const info = { ...this.state.info, projectTypesSelected: [] }
			this.setState({ info });
		}

		else if (isArray === false) {
			if (selectedOptions !== null && selectedOptions.isMultiSelect === true) {
				this.state.info.projectTypesSelected.pop(this.state.info.projectTypesSelected.find(x => x.isMultiSelect === false));
				this.state.info.projectTypesSelected.push(selectedOptions);
				const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
				this.setState({ info });
			}
		}
		//check if the last item select is multi-> remove singles, else -> remove multi
		else if (isArray === true && selectedOptions[selectedOptions.length - 1].isMultiSelect === true) {
			this.state.info.projectTypesSelected.length = 0;
			this.state.info.projectTypesSelected.push(...selectedOptions);
			const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
			this.setState({ info });
		}
		else if (isArray === true && selectedOptions[selectedOptions.length - 1].isMultiSelect === false) {
			selectedOptions = selectedOptions.filter(function (obj) {
				return obj.isMultiSelect === false;
			});
			this.state.info.projectTypesSelected.length = 0;
			this.state.info.projectTypesSelected.push(...selectedOptions);
			const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
			this.setState({ info });
		}
		else {
			this.state.info.projectTypesSelected.length = 0;
			this.state.info.projectTypesSelected.push(...selectedOptions);
			const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
			this.setState({ info });
		}
	}

	handleSelectChangeSingle(selectedOptions) {
		var isArray = Array.isArray(selectedOptions);

		if (selectedOptions === null) {
			const info = { ...this.state.info, projectTypesSelected: [] }
			this.setState({ info });
		}

		else if (isArray === false) {
			this.state.info.projectTypesSelected.length = 0;
			this.state.info.projectTypesSelected.push(selectedOptions);

			const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
			this.setState({ info });

			//single
			if (isArray === true && (selectedOptions.some(x => x.isMultiSelect === false))) {
				this.state.info.projectTypesSelected.length = 0; // clear array
				this.state.info.projectTypesSelected.push(selectedOptions); // insert single item
				const info = { ...this.state.info, projectTypesSelected: this.state.info.projectTypesSelected }
				this.setState({ info });
			}
		}
	}

	renderNumberField(label, name) {
		const id = 'id_ ' + name;
		return (
			<div className="controls">
				<label htmlFor={id}>{label}</label>
				<input id={id} type="number" name={name} min="0"
					value={this.state.info[name]} className="short-input-num"
					onChange={this.changeHandlerNumber(name)}
				/>
			</div>
		);
	}

	renderTextField(label, name) {
		const id = 'id_ ' + name;
		return (
			<div className="controls">
				<label htmlFor={id}>{label}</label>
				<input id={id} type="text" name={name}
					value={this.state.info[name]}
					onChange={this.changeHandler(name)}
				/>
			</div>
		);
	}

	renderSelectField(label, name) {
		return (
			<div className="controls with-select">
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={this.getOptionsFor(name)}
					onChange={this.handleSelectChange(name)}
				/>
			</div>
		);
	}

	renderSelectFieldProgramType(label, name) {
		const { programTypes } = this.props;
		return (
			<div className="controls with-select">
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={getOptionsForProgramType(programTypes, this.props.info.divisionName)}
					onChange={this.handleSelectChange('programTypeId')}
				/>
			</div>
		);
	}

	getProjTypes (projectTypes, divisionName) {

		let divisionId = -1;
		if (divisionName === 'Public Buildings')
			divisionId = 1;
		else if (divisionName === 'Infrastructure')
			divisionId = 0;

		let pts = [];
		if (divisionId !== -1)
			pts = projectTypes.filter(pt => pt.divisionId === divisionId);
		else
			pts = projectTypes;

		if(pts) {
			return pts.map(pt => {
				const value = pt.projectType;
				return { label: value, value: pt.id, isMultiSelect: pt.isMultiSelect }
			});
		}
	}

	renderSelectFieldMulti(label, name) {
		const { projectTypes, info } = this.props;
		return (
			<div className="controls with-select">
				<label>{label}</label>
				<Select name={name} multi
					value={this.state.info.projectTypesSelected}
					options={this.getProjTypes(projectTypes, info.divisionName)}
					onChange={this.handleSelectChangeMulti}
				/>
			</div>
		);
	}

	renderSingleOrMult(label, name) {
		const { projectTypes, info } = this.props;

		//||
		//(this.state.info.projectTypesSelected && this.state.info.projectTypesSelected.length === 0) 

		return (
			<div className="controls with-select">
				<label>{label}</label>
				{( (this.state.info.projectTypesSelected && this.state.info.projectTypesSelected.length > 0 &&
					this.state.info.projectTypesSelected.every(e => e.isMultiSelect === true ) )
					|| (this.state.info.projectTypesSelected && checkMulti(projectTypes, this.state.info.projectTypesSelected.projectTypeId) )
				)



					? <Select name={name} multi disabled={label === 'Project Type'}
						value={this.state.info.projectTypesSelected}
						options={this.getProjTypes(projectTypes, info.divisionName)}
						onChange={this.handleSelectChangeMulti}
					/>

					: <Select name={name}
						value={this.state.info.projectTypesSelected && this.state.info.projectTypesSelected.find(x => x.isMultiSelect === false)}
						options={this.getProjTypes(projectTypes, info.divisionName)}
						onChange={this.handleSelectChangeSingle}
					/>}
			</div>
		);
	}

	handleSelectChangePhase(field) {
		return (option) => {
			const value = option ? option.value : null;
			let isReadOnlySubPhase = false, subPhase = null;
			if (value === 'Procurement') {
				isReadOnlySubPhase = true;
				if (this.props.info.contractProcModelList.length > 0
					&& this.props.info.contractProcModelList[0].procurementStatus !== 'In Design'
					//&& this.props.info.contractProcModelList[0].procurementStatus !=='In Legal'
					&& this.props.info.contractProcModelList[0].procurementStatus !== 'NTP')
					subPhase = this.props.info.contractProcModelList[0].procurementStatus;
				if (subPhase == null)
					subPhase = 'No record found in CDS';
			}
			const info = { ...this.state.info, [field]: value, isReadOnlySubPhase: isReadOnlySubPhase, subPhase: value == 'Design' ? this.props.phaseName : subPhase }
			this.setState({ info });
		}
	}

	renderSelectFieldPhase(label, name) {
		return (
			<div className="controls with-select required" id={this.state.aeRequiredAttributes['phase']}>
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={this.getOptionsForPhase(name)}
					onChange={this.handleSelectChangePhase(name)}
				/>
			</div>
		);
	}

	renderSelectFieldSubPhase(label, name) {
		return (
			<div className="controls with-select required" id={this.state.aeRequiredAttributes['subPhase']}>
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={this.getOptionsForSubPhase(this.props.subPhases.filter(p => p.phaseName === this.state.info.phase && this.props.info.divisionName === p.divisionName))}
					onChange={this.handleSelectChange(name)}
				/>
			</div>
		);
	}

	renderSelectFieldStatus(label, name) {
		return (
			<div className="controls with-select required" id={this.state.aeRequiredAttributes['benchmarkStatus']}>
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={this.getOptionsForStatus()}
					onChange={this.handleSelectChange(name)}
				/>
			</div>
		);
	}

	renderSelectPreviousFY(label, previousFiscalYear) {
		return (
			<div className="controls with-select required" id={this.state.aeRequiredAttributes['previousFiscalYear']}>
				<label>{label}</label>
				<Select previousFiscalYear={previousFiscalYear}
					value={this.state.info[previousFiscalYear]}
					options={this.fiscalYears}
					onChange={this.handleSelectChange(previousFiscalYear)}
				/>
			</div>
		);
	}

	handleCheckboxChange(name) {
		return (e) => {
			const data = this.state.info;

			if (data[name] === true)
				data[name] = false;
			else
				data[name] = true;

			this.setState({ data });
		}
	}

	handleDateChange(name) {
		return (date) => {
			const info = this.state.info;
			info[name] = date;
			this.setState({ info });
		}
	}

	renderSelectCritical() {
		return (
			<div className="controls-padding">
				<label className="label-radio">Critical</label>
				<div>
					<div className="md-radio md-radio-inline">
						<input id="3" type="radio" checked={this.state.info['critical']} onChange={this.handleCheckboxChange('critical')} />
						<label htmlFor="3">Yes</label>
					</div>
					<div className="md-radio md-radio-inline">
						<input id="4" type="radio" checked={!this.state.info['critical']} onChange={this.handleCheckboxChange('critical')} />
						<label htmlFor="4">No</label>
					</div>
				</div>
			</div>
		);
	}
	renderSelectFieldprojectDeliveryMethod(label, name, values) {
		return (
			<div className="controls with-select required" id={this.state.aeRequiredAttributes['projectDeliveryMethod']}>
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={values}
					onChange={this.handleSelectChange(name)}
				/>
			</div>
		);
	}

	renderSelectFieldOther(label, name, values) {
		return (
			<div className="controls with-select">
				<label>{label}</label>
				<Select name={name}
					value={this.state.info[name]}
					options={values}
					onChange={this.handleSelectChange(name)}
				/>
			</div>
		);
	}

	renderScope(text) {
		return (
			<div className="controls">
				<div className="value paraish">
					{text
						? text.split(/(?:\r\n|\r|\n)/g).map((s, i) => <span key={i}>{s}</span>)
						: null}
				</div>
			</div>
		);
	}

	renderWebScope(text) {
		return (
			<div className="controls">
				<div className="value paraish">
					{text
						? text.split(/(?:\r\n|\r|\n)/g).map((s, i) => <span key={i}>{s}</span>)
						: null}
				</div>
			</div>
		);
	}

	handleChangeWs(text) {
		return (e) => {
			this.setState({ webScope: e.target.value });
		};
	}

	renderEditableWebScope(text) {
		return (
			<div className="controls">
				<div className="value paraish">
					<div>
						<span onClick={this.cancelWs} className="btn-cancel" >Cancel</span>
						<button onClick={this.saveWs} className="btn-save">Save</button>
					</div>
					<textarea rows="3"
						value={this.state.webScope}
						onChange={this.handleChangeWs(text)}></textarea>
				</div>
			</div>
		);
	}

	editWebScope(tab) {
		this.setState({ wsEditable: true });
	}

	cancelWs() {
		this.setState({ wsEditable: false });
	}

	saveWs(e) {
		this.state.info.webScope = this.state.webScope;

		const newInfo = {
			...this.props.info,
			...this.state.info,
		};

		e.preventDefault();

		this.props.saveWs(newInfo);
		this.cancelWs();
	}

	renderDateField(label, value) {
		return (
			<div className="controls date-control">
				<label>{label}</label>
				<DateField
					name={value}
					value={this.state.info[value]}
					limits={{}}
					onChange={this.handleDateChange(value)} />
			</div>
		)
	}


	render() {

		const { info, phaseName } = this.props;
		const { activeTab } = this.state;
		const isReadOnlySubPhase = (this.state.info.isReadOnlySubPhase);

		let canSubmit = true;

		let { infraClass } = '';
		if (this.props.info.divisionName === 'Infrastructure')
			infraClass = 'col s12 m6 l3';
		else
			infraClass = 'col s12 l4';

		var leadFmsId = null;
		if (info.projectFMS !== undefined) {
			var leadFms = info.projectFMS.find(f => { return f.leadFMSId === true });
			if (leadFms !== undefined)
				leadFmsId = leadFms.fmsRefId;
		}

		return (
			<form className="clearfix" onSubmit={this.handleSubmit}>
				<div className="col s12">
					{this.props.info.divisionName === 'Infrastructure'
						? <div className="project-flags">
							<div className="flag">
								{info.divisionName === 'Infrastructure' ?
									<button onClick={this.toggleModal} className="padding-left-0">
										<strong>Status Report</strong>
										<span className="margin-left-075"><MdPrint size={20} color='#8492a6' /></span>
									</button> : null}
							</div>
						</div>
						: null}

				</div>
				<div className={infraClass}>
					<div className={info.divisionName === 'Infrastructure' ? 'boxed2' : 'boxed7'}>

						<FieldLike label="Lead FMSID" value={leadFmsId} />
						<FieldLike label="Secondary FMS IDs" value={info.secondaryFmsS && info.secondaryFmsS.join(', ')} />

						<FieldLike label="Division" value={info.divisionName} />
						<FieldLike label="Program unit" value={info.unitName} />
						{this.renderSelectFieldProgramType('Program Type', 'programTypeId')}
						{info.divisionName === 'Public Buildings' && this.renderSelectFieldprojectDeliveryMethod('Project Delivery Method', 'projectDeliveryMethod', [{ label: 'CM Build', value: 'CM Build' }, { label: 'Design Bid Build', value: 'Design Bid Build' }, { label: 'Traditional Design Build ', value: 'Traditional Design Build ' }, { label: 'Progressive Design Build', value: 'Progressive Design Build' }])}
						<FieldLike label="Sponsor" value={info.sponsor} />
						{this.renderSelectFieldStatus('Status', 'benchmarkStatus')}
					</div>
				</div>
				<div className={infraClass}>
					<div className={info.divisionName === 'Infrastructure' ? 'boxed2' : 'boxed7'}>
						{this.renderSelectFieldPhase('Current Phase', 'phase')}
						{this.state.info.phase == 'Design' && info.divisionName != "Infrastructure" && <FieldLike label="Subphase" value={phaseName} />}
						{
							(info.divisionName == "Infrastructure" || (info.divisionName == "Public Buildings" && this.state.info.phase != 'Design')) && ((isReadOnlySubPhase) ? <FieldLike label="Subphase" value={this.state.info.subPhase} />
								: this.renderSelectFieldSubPhase('Subphase', 'subPhase'))
						}
						{this.renderSingleOrMult('Project Type', 'projectType')}
						{this.renderSelectField('Priority', 'priority')}
						<div className="controls padding-bottom-0">
							<span className="label underline">Contract Type:</span>
						</div>
						{this.renderSelectField('Design', 'designContractType')}
						{this.renderSelectField('Construction', 'constructionContractType')}
					</div>
				</div>
				{info.divisionName === 'Infrastructure'
					? <div className={infraClass}>
						<div className="boxed3">
							{this.renderSelectFieldOther('Design By', 'designBy', [{ label: 'In-House', value: 'In-House' }, { label: 'External', value: 'External' }])}
							{this.renderSelectFieldOther('Design Group', 'designGroup', [{ label: '1', value: '1' }, { label: '2', value: '2' }])}
							{this.renderSelectFieldOther('CM Boro', 'cmBoro', [
								{ label: 'Manhattan', value: 'Manhattan' },
								{ label: 'Brooklyn', value: 'Brooklyn' },
								{ label: 'Queens', value: 'Queens' },
								{ label: 'Bronx', value: 'Bronx' },
								{ label: 'Staten Island', value: 'Staten Island' },
								{ label: 'DEP Managed', value: 'DEP Managed' },
								{ label: 'DOT Managed', value: 'DOT Managed' }])}
							{this.renderSelectFieldOther('Construction FY', 'constructionFiscalYear', this.fiscalYears)}
							{this.renderSelectFieldOther('Design FY', 'designFiscalYear', this.fiscalYears)}
							{this.renderSelectPreviousFY('Original FY', 'previousFiscalYear')}
						</div>
					</div>
					: null}
				<div className={infraClass}>
					<div className={info.divisionName === 'Infrastructure' ? 'boxed2' : 'boxed7'}>
						<Tabs
							tabs={SCOPE_TABS}
							current={this.state.activeTab}
							setTab={this.setActiveTab}
							editWs={this.editWebScope}
							canEditWs={this.props.canEditWebScope}
						/>
						{activeTab === 'scope' && this.renderScope(info.scope)}

						{activeTab === 'webScope' && this.state.wsEditable === false
							? this.renderWebScope(info.webScope)
							: activeTab === 'webScope' && this.state.wsEditable === true && this.props.canEditWebScope === true
								? this.renderEditableWebScope(info.webScope)
								: null}
					</div>
				</div>

				<div className="section-buttons" id="sectionBtnsInfo">
					<span className="btn-cancel" onClick={this.handleCancel}>Cancel</span>
					<button className="btn-save" disabled={!canSubmit}>Save</button>
				</div>
			</form>
		);
	}
}

InfoForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	info: PropTypes.object.isRequired,
	setup: PropTypes.object.isRequired
};

export default InfoForm;